import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { TabsService } from 'src/app/shared/components/tabs/tabs.service';
import { Result } from 'src/app/shared/model/response.model';
import { DataService } from 'src/app/shared/services/data.service';
import { StorageService } from 'src/app/shared/services/storage.service';
import { BOM_REQUIRED_FIELDS, COMPANY_REQUIRED_VALUES, CROSSWALK_REQUIRED_VALUES, ImportBOMCommand, ImportCodeCrosswalkData, ImportCompanyCommand ,VENDOR_REQUIRED_VALUES} from './import-documents.model';
import { URLS } from 'src/app/components/crm/crm-api-constants';
import { IMPORT_API } from 'src/app/shared/import/import-api.constants';
@Injectable({
  providedIn: 'root'
})
export class ImportDocumentsService {
  count: number=0;
  tabs = [];
  submit:boolean=false
  indexActive=0;
  submitted:boolean=false;

public dataPassAccordingToTrackingBar = new BehaviorSubject<any>(undefined);
public progressbarValue = new BehaviorSubject(undefined);
public previuosTab = new BehaviorSubject(false);
public mapValidation = new BehaviorSubject<boolean>(true);
public applyChanges = new BehaviorSubject(undefined);
public toEnd = new BehaviorSubject(undefined);
public errorValidation = new BehaviorSubject<boolean>(true);
public fileName = new BehaviorSubject(undefined);
public mapTabShow = new BehaviorSubject<boolean>(false);
public fileChangeNotifier = new BehaviorSubject<{ timestamp: number, fileHash?: string }>(undefined);
public isMappingChanged = new BehaviorSubject<boolean>(false);




  constructor(public dataService:DataService,
    private tabsService: TabsService,
    private router: Router,
    public storageService: StorageService) { }



  public getImportDropDownList ():Observable<Result>{
    let url=URLS.dropDown.importDropDownList;
    return this.dataService.get(url, '').pipe<Result>(tap((response:any)=>{
    return response;
    }))
  }
  public deleteTemplateByTemplateId (id):Observable<Result>{
    let url=`${IMPORT_API.common.deleteTemplateByTemplateId}?TemplateId=${id}`;
    return this.dataService.get(url, '').pipe<Result>(tap((response:any)=>{
    return response;
    }))
  }


  public getImportCompanyTemplateById (id:any,sourceId : number):Observable<Result>{
    let url = `${IMPORT_API.common.getTemplateByTemplateId}?TemplateId=${id}&sourceId=${sourceId}`;
    return this.dataService.get(url, '').pipe<Result>(tap((response:any)=>{
    return response;
    }))
  }

  public validateFile(data:any):Observable<Result>{
    let url= IMPORT_API.common.validateFileWithTemplate;
    return this.dataService.post(url,data).pipe<Result>(tap((response:any)=>{
    return response;
    }))
  }


  public validateFileHasData(data:any):Observable<Result>{
    let url= IMPORT_API.common.validateFileHasData;
    return this.dataService.post(url,data).pipe<Result>(tap((response:any)=>{
    return response;
    }))
  }




  public mapToList (data:any):Observable<Result>{
    let url=IMPORT_API.common.getHeaderNameListFromFile;
    const myjson=JSON.stringify(data)
    return this.dataService.post(url, data).pipe<Result>(tap((response:any)=>{
      return response;
    }))
  }

  public InsertImportCompanyData (data:any):Observable<Result>{
    const myjson=JSON.stringify(data)
    let url=IMPORT_API.crm.importCompanyTemplate;
    return this.dataService.post(url, data).pipe<Result>(tap((response:any)=>{
      return response;
    }))
  }

  public InsertImportCodeCrosswalkTemplate (data:any):Observable<Result>{
    const myjson=JSON.stringify(data)
    let url= IMPORT_API.master.importCodeCrosswalkTemplate;
    return this.dataService.post(url, data).pipe<Result>(tap((response:any)=>{
      return response;
    }))
  } 

  public InsertImportBOMTemplate (data:any):Observable<Result>{
    const myjson=JSON.stringify(data)
    let url= IMPORT_API.sales.importRequirementTemplate;
    return this.dataService.post(url, data).pipe<Result>(tap((response:any)=>{
      return response;
    }))
  }


  public insertImportOnlyCompany (data:ImportCompanyCommand):Observable<Result>{
    const myjson=JSON.stringify(data)
    let url= IMPORT_API.crm.importCompany;
    return this.dataService.post(url, data).pipe<Result>(tap((response:any)=>{
      return response;
    }))
  }

  public insertImportCodeCrosswalk (data:ImportCodeCrosswalkData):Observable<Result>{
    const myjson=JSON.stringify(data)
    let url= IMPORT_API.master.importCodeCrosswalk;
    return this.dataService.post(url, data).pipe<Result>(tap((response:any)=>{
      return response;
    }))
  }

  public insertImportBOM (data:ImportBOMCommand):Observable<Result>{
    const myjson=JSON.stringify(data)
    let url= IMPORT_API.sales.importRequirementRecords;
    return this.dataService.post(url, data).pipe<Result>(tap((response:any)=>{
      return response;
    }))
  }
  //#region Part And Inventory API
   public importInventory (data:any):Observable<Result>{
    const myjson=JSON.stringify(data)
    let url= IMPORT_API.master.importCodeCrosswalkTemplate;
    return this.dataService.post(url, data).pipe<Result>(tap((response:any)=>{
      return response;
    }))
  } 

  //#endregion

  public closeTab(data?) {
    this.indexActive = 0
    this.count = 0
    this.tabs = [];
    const index=this.tabsService?.tabs?.findIndex(a=>a.title==='Import Companies' || a.title=== data )
    this.tabsService.tabs.splice(index,1);
    this.tabs =this.tabsService?.tabs
    this.tabsService.allOpenedTabs.splice(index,1);
    this.storageService.store("allTabs",this.tabsService.tabs);
   // this.router.navigateByUrl(this.tabsService.tabs[index-1].path);
    this.tabsService.deleteTab(index);
    this.dataPassAccordingToTrackingBar = new BehaviorSubject(undefined);
  }

  public closeVendorTab() {
    this.indexActive = 0
    this.count = 0
    this.tabs = [];
    const index=this.tabsService?.tabs?.findIndex(a=>a.title==='Import Vendors')
    this.tabsService.tabs.splice(index,1);
    this.tabs =this.tabsService?.tabs
    this.tabsService.allOpenedTabs.splice(index,1);
    this.storageService.store("allTabs",this.tabsService.tabs);
   // this.router.navigateByUrl(this.tabsService.tabs[index-1].path);
    this.tabsService.deleteTab(index);
    this.dataPassAccordingToTrackingBar = new BehaviorSubject(undefined);
  }

  public closeBOMTab() {
    this.indexActive = 0
    this.count = 0
    this.tabs = [];
    const index=this.tabsService?.tabs?.findIndex(a=>a.title==='Import BOM')
    this.tabsService.tabs.splice(index,1);
    this.tabs =this.tabsService?.tabs
    this.tabsService.allOpenedTabs.splice(index,1);
    this.storageService.store("allTabs",this.tabsService.tabs);
   // this.router.navigateByUrl(this.tabsService.tabs[index-1].path);
    this.tabsService.deleteTab(index);
    this.dataPassAccordingToTrackingBar = new BehaviorSubject(undefined);
  }

  checkRequiredValueCodecrosswalk(list): boolean {
    let count:number=0;
    const intialList = list.filter(a => a.status === true);
    for (let i = 0; i < intialList.length; i++) {
      let systemColumn = intialList[i].systemColumn
      if (CROSSWALK_REQUIRED_VALUES.includes(systemColumn)) {
        count ++;
        if (count === CROSSWALK_REQUIRED_VALUES?.length) {
          return true
        }

      }
    }
    return false
  }

  checkRequiredValue(list): boolean {
    let count:number=0;
    const intialList = list.filter(a => a.status === true);
    for (let i = 0; i < intialList.length; i++) {
      let systemColumn = intialList[i].systemColumn
      if (COMPANY_REQUIRED_VALUES.includes(systemColumn)) {
        count ++;
        if (count === COMPANY_REQUIRED_VALUES.length) {
          return true
        }

      }
    }
    return false
  }

  checkVendorRequiredValue(list): boolean {
    let count:number=0;
    const intialList = list.filter(a => a.status === true);
    for (let i = 0; i < intialList.length; i++) {
      let systemColumn = intialList[i].systemColumn
      if (VENDOR_REQUIRED_VALUES.includes(systemColumn)) {
        count ++;
        if (count === VENDOR_REQUIRED_VALUES?.length) {
          return true
        }

      }
    }
    return false
  }


  checkRequiredValueError(list): boolean {
    let count:number=0;
    const listData = list?.map(x=>x. companyName);
    const intialList = list.filter(a => a.status === true);
    for (let i = 0; i < intialList.length; i++) {
      let systemColumn = intialList[i].systemColumn
      if (listData.includes(systemColumn)) {
        count ++;
        if (count === list.length) {
          return true
        }

      }
    }
    return false
  }
  checkRequiredMapValue(list,requiredField): boolean {
    let count:number=0;
    const intialList = list.filter(a => a.status === true);
    for (let i = 0; i < intialList.length; i++) {
      let systemColumn = intialList[i].systemColumn
      if (requiredField.includes(systemColumn)) {
        count ++;
        if (count === requiredField?.length) {
          return true
        }

      }
    }
    return false
  }

  checkBOMRequiredValue(list): boolean {
    let count:number=0;
    const intialList = list.filter(a => a.status === true);
    for (let i = 0; i < intialList.length; i++) {
      let systemColumn = intialList[i].systemColumn
      if (BOM_REQUIRED_FIELDS.includes(systemColumn)) {
        count ++;
        if (count === BOM_REQUIRED_FIELDS?.length) {
          return true
        }

      }
    }
    return false
  }

}
